import {
  BEGIN_EDITING_GOALS,
  SAVE_GOALS,
  SAVE_GOALS_SUCCESS,
  SAVE_GOALS_ERROR,
  END_EDITING_GOALS,
} from '../actions/types';

//user state can be false (if not logged in), authenticating (if currently fetching user), or the user{} object

const DEFAULT_STATE = {
  editing: false,
  data: null,
  syncingWithServer: false,
  error: null,
  message: null,
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case BEGIN_EDITING_GOALS:
      return {
        editing: true,
        data: action.payload,
        syncingWithServer: false,
        error: null,
        message: null,
      }
    case SAVE_GOALS:
      return {
        ...state,
        syncingWithServer: true,
        error: null,
        message: null,
      }
    case SAVE_GOALS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        syncingWithServer: false,
        error: null,
        message: action.payload.message,
      }
    case SAVE_GOALS_ERROR:
      return {
        ...state,
        syncingWithServer: false,
        error: action.payload,
        message: null,
      }
    case END_EDITING_GOALS:
      return DEFAULT_STATE;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/editingGoalsReducer.js